import { createPortal } from "react-dom";
import { useEffect } from "react";
import styled from "styled-components";
import { useGlobalChat } from "../../context/GlobalChatContext";
import AIMentorChatPage from "../../pages/AiMentorChatPage";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.74);
  backdrop-filter: blur(10px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;

  @media (max-width: 640px) {
    padding: 0;
    align-items: stretch;
  }
`;

const Modal = styled.div`
  width: min(760px, calc(100vw - 32px));
  height: min(820px, calc(100dvh - 32px));
  overflow: hidden;
  border-radius: 30px;
  background:
    linear-gradient(180deg, rgba(15, 23, 42, 0.96), rgba(2, 6, 23, 0.94)),
    linear-gradient(135deg, rgba(245, 158, 11, 0.12), rgba(56, 189, 248, 0.1));
  border: 1px solid rgba(148, 163, 184, 0.16);
  box-shadow: 0 34px 100px rgba(0, 0, 0, 0.56);
  color: #e2e8f0;
  display: flex;
  flex-direction: column;
  min-height: 0;

  @media (max-width: 640px) {
    width: 100%;
    height: 100dvh;
    border-radius: 0;
    max-height: none;
  }
`;

export default function ChatbotModal() {
  const { open, closeChat, chatConfig } = useGlobalChat();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <Overlay onClick={closeChat}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <AIMentorChatPage
          onClose={closeChat}
          assistantMode={chatConfig?.assistantMode}
          dayContext={chatConfig?.dayContext}
        />
      </Modal>
    </Overlay>,
    document.body
  );
}
